import React from "react";
import { IconProps } from "./IconProps";

const InProgress: React.FC<IconProps> = ({
    size = 20,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 17 16"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_11289_40089)">
                <path
                    d="M8.49967 0.666016V3.33268M8.49967 11.3327V13.9993M4.49967 7.33268H1.83301M15.1663 7.33268H12.4997M13.2186 12.0516L11.333 10.166M13.2186 2.66598L11.333 4.55159M3.78072 12.0516L5.66634 10.166M3.78072 2.66598L5.66634 4.55159"
                    stroke="#F79009"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11289_40089">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default InProgress;
